<template>
    <div>
        <b-alert
            :show="dismissCountDown"
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            style="z-index:1;position:absolute; top: 10px; right: 10px"
        >{{message}}</b-alert>
        <div @click="copy()">
            <span :id="randomId" class="link"><slot/></span>
        </div>
    </div>
</template>
  <style>
    .link:hover {
        color: #25bf43;
        cursor: grab
    }
  </style>
<script>
export default {
	props: ['alertDisplayLength', 'alertShowCopiedText', 'textToCopy' ],
	data() {
		return {
            randomId: Math.random().toString(36), // this is probably a dumb idea, but it works.
            dismissCountDown: 0,
            message: "Text wurde in die Zwischenablage gelegt."
        }
    },
    methods: {
        countDownChanged(dismissCountDown) { this.dismissCountDown = dismissCountDown },
        copy() {
            const el = document.createElement('textarea');
            
            if(this.textToCopy) {
                el.value = this.textToCopy;
            }else{
                el.value = document.getElementById(this.randomId).innerText;
            }

            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            if(this.alertShowCopiedText) {
                this.message = `»${el.value}« wurde in die Zwischenablage gelegt.`
            }else{
                this.message = "Text wurde in die Zwischenablage gelegt.";
            }
            document.body.removeChild(el);
            //this.dismissCountDown = this.alertDisplayLength;
            this.$bvToast.toast( this.message, {
                title: 'Copy To Clipboard',
                autoHideDelay: 4000,
                appendToast: false
            });
        }
    }
};
</script>
